<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <b-form>
            <b-form-group
              label="Nro. Presupuesto:"
              label-for="presupuestoInternoId"
              :label-cols="labelCols"
              horizontal
              description="Ingrese el número de Presupuesto a seleccionar y haga click en el botón de búsqueda">
              <b-input-group>
                <b-form-input 
                  id="presupuestoInternoId"
                  class="number-input"
                  v-model.number="presupuestoInternoId" 
                  type="number"
                  @focus="$event.target.select()"
                  @keyup.enter="getPresupuestoInterno"/>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="getPresupuestoInterno">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            
            <br>

            <b-form-group
              label="Cliente:"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="cliente" 
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              label="Acción:"
              label-for="accion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="accion"
                :value="accion" 
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              label="Importe"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { required, decimal, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'transferenciaPremiosPresupuesto/getField',
  mutationType: 'transferenciaPremiosPresupuesto/updateField',
});

export default {
  name: 'TransferenciaPremiosPresupuesto',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data () {
    return {
      noValidar: true,
      importeValido: null,
      importeInvalidoMsj: '',

      labelCols: 3,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',
    }
  },
  computed: {
    ...mapFields([
      'presupuestoInternoId',
      'cliente',
      'accion',
      'importe',
    ])
  },  
  created() {
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal || !this.$v.importe.minValue) {
            this.importeInvalidoMsj = 'El importe asignado debe ser un valor numérico positivo';
          }
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      if (this.presupuestoInternoId == 0) {
        this.showAlert('Seleccione el presupuesto interno correspondiente.', 'danger');
        save = false; 
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.$emit('close', true)
        }
      } 
    },
    close() {
      this.$emit('close', false);
    },

    getPresupuestoInterno() {
      this.cliente = '';
      this.accion = '';

      let presupuestoInternoId = 0;
      if (this.presupuestoInternoId) {
        if (!isNaN(this.presupuestoInternoId)) {
          presupuestoInternoId = parseInt(this.presupuestoInternoId);
        }
      }

      if (presupuestoInternoId != 0) {
        let params = {
          clienteId: this.clienteId,
          presupuestoInternoId,
          logistica: false
        }

        this.showSpinner();
        this.$store.dispatch('presupuestointerno/searchPresupuesto', params)
          .then(() => {
            let presupuestoInterno = this.$store.getters['presupuestointerno/presupuestoSearch'];

            this.presupuestoInternoId = presupuestoInterno.id;
            this.cliente = presupuestoInterno.cliente;
            this.accion = presupuestoInterno.accion;
          })
          .catch(error => this.showAlert(error, 'danger'))
          .finally(() => this.hideSpinner())
      } else {
        this.showAlert('Verifique el número de presupuesto ingresado', 'danger');
      }
    },

    // seleccionarPresupuestoInterno() {
    //   this.$refs.searchPresupuestoInternoModal.show()
    // },
    // presupuestoInternoSeleccionado(params) {
    //   this.$refs.searchPresupuestoInternoModal.hide();
    //   if (params.presupuestoInterno.id != 0) {
    //     this.presupuestoInternoId = params.presupuestoInterno.id;
    //     this.cliente = params.presupuestoInterno.cliente;
    //     this.accion = params.presupuestoInterno.accion;
    //   } else {
    //     this.presupuestoInternoId = 0;
    //     this.cliente = '';
    //     this.accion = '';
    //   }
    // },
    // cancelaSeleccionPresupuestoInterno() {
    //   this.$refs.searchPresupuestoInternoModal.hide()
    // },
    // borrarSeleccionPresupuestoInterno() {
    //   this.presupuestoInternoId = 0;
    //   this.cliente = '';
    //   this.accion = '';
    // }
  },
  watch: {
  },
  validations: {
    importe: {
      required,
      decimal,
      minValue: minValue(0.01),      
    },
  },  
}
</script>

<style>
</style>
